import React, { FC } from 'react';
import { useEffect, useState } from 'react';
import { Route, Routes, useParams } from 'react-router-dom';
import { api } from 'services/api';
import { Place } from 'types/place';
import { initialPlace, initialMeta } from 'services/initialStates';
import { PlaceMainPage } from 'client/pages/Main/PlaceMainPage';
import { Meta } from 'types/meta';
import { Loading } from 'common/components/Loading';
import { LoadingError } from 'common/components/LoadingError';
import { useTranslation } from 'react-i18next';
import { FullScreen } from 'styles/FullScreen';
import { FormPage } from 'client/pages/Form/FormPage';
import { BackgroundImage } from 'styles/BackgroundImage';
import { QrType } from 'types/qrType';
import { MenuPage } from 'client/pages/MenuPage';
import { ActionSentPage } from 'client/pages/ActionSentPage';

export const PlaceDispatcher: FC<{ qrType: QrType }> = ({ qrType }) => {
  const { hash } = useParams() as { hash: string };
  const [meta, setMeta] = useState<Meta>(initialMeta);
  const [place, setPlace] = useState<Place>(initialPlace);
  const [loading, setLoading] = useState(true);
  const [loadingError, setLoadingError] = useState(false);
  const { t } = useTranslation();

  useEffect(() => {
    retrievePlace();
  }, []);

  const retrievePlace = () => {
    api()
      .getPlace(hash, qrType)
      .then(response => {
        if (response.error) setLoadingError(true);
        else {
          setPlace(response.data);
          setMeta(response.meta);
          setLoading(false);
        }
      });
  };

  if (loading) return <Loading />;
  if (loadingError)
    return <LoadingError error={t('failedToRetrieveCompanyData')} />;
  return (
    <FullScreen>
      <BackgroundImage source={meta.background} />
      <Routes>
        <Route
          path="/"
          element={
            <PlaceMainPage
              place={place}
              meta={meta}
              qrType={qrType}
              hash={hash}
            />
          }
        />
        <Route
          path="feedback"
          element={
            <FormPage
              entity={place}
              meta={meta}
              qrType={qrType}
              preview={false}
            />
          }
        />
        <Route
          path="menu/:id"
          element={
            <MenuPage entity={place} company={place.company} meta={meta} />
          }
        />
        <Route path="/launch_action" element={<ActionSentPage meta={meta} />} />
      </Routes>
    </FullScreen>
  );
};
